export const colors = {
    orangePrimary: "#fea730",
    bluePrimary: "#051032",
    orangeDark: "#ed9e00",
    blueDark: "#122140"
}
